import {
  ChakraProvider,
  theme
} from "@chakra-ui/react"
import { Buffer } from "buffer"
import { Route, Routes } from "react-router-dom"
import LoadingPage from "./Loading"
import LoginPage from "./modules/auth/pages/Login"
import SsoCallbackPage from "./modules/auth/pages/SsoCallback"
import GetInPage from "./modules/dashboard/pages/GetIn"
import LooksGoodPage from "./modules/dashboard/pages/LooksGood"
import { UserContext, UserContextProps, UserProvider } from "./providers/UserProvider"
import { useContext } from "react"
import Innovation from "./modules/dashboard/pages/Innovation"

declare global {
  interface Window { process: any; Buffer: any }
}

window.process = window.process || {};
window.Buffer = window.Buffer || Buffer;

export const App = () => {
 const user_context = useContext(UserContext) as UserContextProps
  return (
    <ChakraProvider theme={theme}>
      <UserProvider>
        { user_context?.user }
        <Routes>
            <Route path='/' Component={LoadingPage} />
            <Route path='/login' Component={LoginPage} />
            <Route path='/auth/callback' Component={SsoCallbackPage} />
            <Route path='/get-in' Component={GetInPage} />
            <Route path='/looks-good' Component={LooksGoodPage} />
            <Route path='/innovation' Component={Innovation} />
          </Routes>
      </UserProvider>
        
    </ChakraProvider>
  )
}
